<template>
  <b-container>
    <b-modal
      id="newAppModal"
      ref="newAppModal"
      :title="title"
      @hidden="handleHidden"
      @ok="handleOk"
    >
      <form ref="form" @submit.stop.prevent="handleSubmit">
        <avatar />
        <br />
        <b-form-group
          :state="nameState"
          label="App Name"
          label-for="name-input"
          invalid-feedback="App name is required"
        >
          <b-form-input id="name-input" v-model="name" :value="name" :state="nameState" requires></b-form-input>
        </b-form-group>
      </form>
    </b-modal>
  </b-container>
</template>

<script>
import Avatar from './Avatar';
import axios from 'axios';

export default {
  components: {
    Avatar
  },
  data() {
    return {
      title: 'Create a new App',
      hasApps: true,
      name: '',
      nameState: null,
      isNewModal: true,
      productId: ''
    };
  },
  beforeRouteEnter(to, from, next) {
    let path = to.fullPath;
    path = path.slice(-4);
    path;
    // check if new app or edit app route is used
    if (path === '/new') {
      next();
    } else {
      axios.get(process.env.VUE_APP_BASE_URL + to.fullPath).then(response => {
        next(vm => {
          vm.setData(response);
        });
      });
    }
  },
  methods: {
    setData(app) {
      app;
      this.name = app.data.name;
      this.isNewModal = false;
      this.title = 'Edit App';
      this.appId = app.data.url;
      this.$nextTick(() => {
        document.querySelector('img.card-img.avatar').src = app.data.icon;
      });
    },
    showModal() {
      this.$refs['newAppModal'].show();
    },
    closeModal() {
      this.$refs['newAppModal'].hide();
    },
    checkFormValidity() {
      const valid = this.$refs.form.checkValidity();
      this.nameState = valid ? 'valid' : 'invalid';
      return valid;
    },
    handleHidden() {
      this.$router.back();
    },
    handleOk(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault();
      // Trigger submit handler
      this.handleSubmit();
    },
    handleSubmit() {
      // Exit when the form isn't valid
      if (!this.checkFormValidity()) {
        return;
      }
      let imageUrl = document.querySelector('img.card-img.avatar').src;
      let path = this.$router.currentRoute.fullPath;
      path = path.substring(0, path.length - 3); //remove /new from string
      if (this.isNewModal) {
        axios
          .post(process.env.VUE_APP_BASE_URL + path, {
            name: this.name,
            iconUrl: imageUrl
          })
          .then(() => {})
          .catch(() => {});
      } else {
        path = path.substring(0, path.length - 1); //remove /e from string
        axios
          .put(process.env.VUE_APP_BASE_URL + path, {
            name: this.name,
            iconUrl: imageUrl
          })
          .then(() => {})
          .catch(() => {});
      }

      this.$nextTick(() => {
        this.closeModal();
      });
    }
  },
  mounted: function() {
    this.$nextTick(function() {
      this.showModal();
    });
  }
};
</script>